import React, { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import CardImg from "../../../../components/CardImg";

const BALLS_BASE = `${import.meta.env.BASE_URL}img/superOver/balls`;

// Reference Ball component: "ASS" -> A, "10SS" -> 10 (3 chars -> 1, 4 chars -> 2); "1" -> no image
const ballValue = (token) => (token.length === 3 ? token.slice(0, 1) : token.length === 4 ? token.slice(0, 2) : null);

/**
 * Video card overlay of the five-cricket pages (reference markup):
 *   .casino-video-cards(.hide-cards) > .casino-cards-shuffle + .casino-video-cards-container > 6 x div > span(s)
 * The t1.card string holds 6 balls separated by "|" (each may hold several cards joined by ",").
 * kind "balls" (superover): span > img superOver/balls/{value}.png; kind "cards" (cricketv3): span > img cards/{card}.png.
 * The shuffle button toggles the cards like the reference (not while the first ball is still "1").
 */
export default function FiveCricketCardsOverlay({ card, kind = "balls" }) {
  const [showCards, setShowCards] = useState(true);
  const cards = String(card || "").split("|");
  if (!card || !cards.length) return null;
  const hidden = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  return (
    <div className={`casino-video-cards${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        {Array.from({ length: 6 }, (_, i) => (
          <div key={i}>
            {String(cards[i] ?? "").split(",").map((token, j) => {
              const t = token.trim();
              if (kind === "cards") {
                return (
                  <span key={j}>
                    <CardImg src={getCardImage(t)} alt="" />
                  </span>
                );
              }
              const v = ballValue(t);
              return <span key={j}>{v && <img src={`${BALLS_BASE}/${v}.png`} alt="" />}</span>;
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
